<template>
  <div class="row inner-menu justify-content-center">
    <div class="col text-center">
      <router-link exact :to="viewLink" v-bind:class="{ active: isViewData }" class="btn btn-success-underline">Dati</router-link>
      <router-link :to="sitesLink" v-bind:class="{ active: isSites }" class="btn btn-success-underline">Siti</router-link>
      <router-link :to="usersLink" v-bind:class="{ active: isUsers }" class="btn btn-success-underline">Utenti</router-link>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    viewLink() { return "/customers/" + this.$route.params.guid },
    usersLink() { return "/customers/" + this.$route.params.guid + "/users" },
    sitesLink() { return "/customers/" + this.$route.params.guid + "/sites" },
    isViewData() { return this.currentPage == "view" },
    isCustomerEdit() { return this.currentPage == "customerEdit" },
    isUsers() { return this.currentPage == "users" },
    isSites() { return this.currentPage == "sites" },
  }
}
</script>

<style scoped>
  .inner-menu {
    margin-bottom: 50px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Admin/Menu.vue